import React from 'react';
import { connect } from 'react-redux';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import CollectionCards from '../components/CollectionCards';
import CollectionsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/CollectionsPanelContainer';
import CollectionsFilters from './CollectionsFilters';

const CollectionsPanelNarrow = ({
  allowMultiSelect,
  canCreate,
  canRead,
  category,
  currentPage,
  collections,
  fetchData,
  newCollectionCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus, reFetchConfig(collections, { pageSize, total }));
  return (
    <CollectionsPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-collections-panel-narrow">
      <div className="sticky-panel-header">
        <CollectionsFilters category={category} className="aridhia-list-filter" fluid />
      </div>
      <CollectionCards
        canCreate={canCreate}
        category={category}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={collections}
        itemsPerRow={1}
        newCollectionCode={newCollectionCode}
        onCheckBoxClick={allowMultiSelect ? (value) => onCheckBoxClick(category, value) : undefined}
        readErrors={readErrors}
        readStatus={readStatus}
      />
    </CollectionsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionsPanelNarrow);
